import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    this.element.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
